// extracted by mini-css-extract-plugin
export default {"datePicker":"styles_datePicker__YJy8P","calender-icon":"styles_calender-icon__-UZFx"};